import { render } from "./Register.vue?vue&type=template&id=2786b8b7&scoped=true"
import script from "./Register.vue?vue&type=script&lang=js"
export * from "./Register.vue?vue&type=script&lang=js"

import "./Register.vue?vue&type=style&index=0&id=2786b8b7&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2786b8b7"

export default script